import { render, staticRenderFns } from "./DoctorPageLpuList.vue?vue&type=template&id=f6852fce&"
import script from "./DoctorPageLpuList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DoctorPageLpuList.vue?vue&type=style&index=0&id=f6852fce&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6852fce')) {
      api.createRecord('f6852fce', component.options)
    } else {
      api.reload('f6852fce', component.options)
    }
    module.hot.accept("./DoctorPageLpuList.vue?vue&type=template&id=f6852fce&", function () {
      api.rerender('f6852fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/DoctorPageLpuList.vue"
export default component.exports